// API сервис для работы с backend
// Используем переменную окружения или определяем по hostname
const getApiBaseUrl = () => {
  // Если мы на домене davidworldon.com - используем относительный путь
  if (typeof window !== 'undefined' && window.location.hostname.includes('davidworldon.com')) {
    return '/api';
  }
  // Иначе localhost: бэкенд driversworldsite — порт 3002 (3001 — другой сервис, taxi-mobile)
  return process.env.REACT_APP_API_URL || 'http://localhost:3002/api';
};

const API_BASE_URL = getApiBaseUrl();

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  // Универсальный метод для выполнения запросов
  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...options.headers
      },
      ...options
    };

    try {
      const response = await fetch(url, config);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка запроса');
      }

      return data;
    } catch (error) {
      console.error('API Error:', error);
      throw error;
    }
  }

  // Создание нового водителя
  async createDriver(driverData) {
    return this.request('/drivers', {
      method: 'POST',
      body: JSON.stringify(driverData)
    });
  }

  // Отправка кода подтверждения на телефон
  async sendVerificationCode(phone) {
    return this.request('/drivers/send-verification-code', {
      method: 'POST',
      body: JSON.stringify({ phone })
    });
  }

  // Подтверждение SMS-кода
  async verifyPhoneCode(phone, code) {
    return this.request('/drivers/verify-phone-code', {
      method: 'POST',
      body: JSON.stringify({ phone, code })
    });
  }

  // Отправка кода подтверждения на email
  async sendEmailVerificationCode(email) {
    return this.request('/drivers/send-email-verification-code', {
      method: 'POST',
      body: JSON.stringify({ email })
    });
  }

  // Подтверждение email-кода
  async verifyEmailCode(email, code) {
    return this.request('/drivers/verify-email-code', {
      method: 'POST',
      body: JSON.stringify({ email, code })
    });
  }

  // Загрузка документа
  async uploadDocument(driverId, documentType, file) {
    const formData = new FormData();
    formData.append('driver_id', driverId);
    formData.append('document_type', documentType);
    formData.append('document', file);

    return this.request('/drivers/upload-document', {
      method: 'POST',
      headers: {}, // Убираем Content-Type для FormData
      body: formData
    });
  }

  // Загрузка документа из base64
  async uploadDocumentFromBase64(driverId, documentType, base64Data, filename) {
    // Конвертируем base64 в File
    const byteString = atob(base64Data.split(',')[1]);
    const mimeString = base64Data.split(',')[0].split(':')[1].split(';')[0];
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    
    const file = new File([ab], filename, { type: mimeString });
    
    return this.uploadDocument(driverId, documentType, file);
  }

  // Завершение регистрации
  async completeRegistration(driverId) {
    return this.request('/drivers/complete-registration', {
      method: 'POST',
      body: JSON.stringify({ driver_id: driverId })
    });
  }

  // Получение информации о водителе
  async getDriver(phone) {
    return this.request(`/drivers/${encodeURIComponent(phone)}`);
  }

  // Получение URL документа
  getDocumentUrl(driverId, documentType) {
    return `${this.baseURL}/drivers/${driverId}/document/${documentType}`;
  }

  // Проверка состояния сервера
  async checkHealth() {
    try {
      const response = await fetch(`${this.baseURL.replace('/api', '')}/health`);
      return await response.json();
    } catch (error) {
      console.error('Health check failed:', error);
      return { status: 'error', database: 'disconnected' };
    }
  }
}

// Экспортируем экземпляр сервиса
const apiService = new ApiService();
export default apiService;
